const a = (r) => {
  let e = r.toLowerCase();
  return e = e.normalize("NFD").replace(/[\u0300-\u036f]/g, ""), e = e.replace(/[^a-z0-9\s-]/g, ""), e = e.replace(/\s+/g, "-"), e = e.replace(/^-+|-+$/g, ""), e.match(/^\d/) && (e = `_${e}`), e;
};
export {
  a as convertToHtmlId
};
